module.exports = __webpack_public_path__ + "static/img/steped4.6a800868.png";